export const HEADER_HEIGHT = '40px';